module.exports = __webpack_public_path__ + "static/img/gm_open06.739d2bc3.png";